import { Injectable } from '@angular/core';
import { AuthenticatedHttpService } from './authenticatedHttpService.service';
import { LocalStorageService } from './local-storage.service';
import { AllocationModel } from 'src/shared/models/statistics/allocation.model';
import { environment } from 'src/environments/environment';
import { StatisticModel } from 'src/shared/models/user/statistic.model';
import { HttpUtils } from 'src/shared/utils/http-utils';
import { UserModel } from 'src/shared/models/user/user.model';
import { StatisticsUserModel } from 'src/shared/models/statistics/statistics-user.model';

@Injectable({ providedIn: 'root' })
export class StatisticsProvider {
  private readonly MODEL: string = 'me/getStatisticsAllByDbId';

  constructor(
    private http: AuthenticatedHttpService,
    private storage: LocalStorageService
  ) {}

  getCurrentUserStatistics(): Promise<Array<AllocationModel>> {
    return new Promise((resolve, reject) => {
      this.http
        .get(environment.web.apiUrl + this.MODEL)
        .then((res) => {
          let result: Array<AllocationModel> = [];
          for (let i = 0; i < res.length; i++) {
            let allocation = res[i];
            result.push(this.creatAllocation(allocation));
          }
          this.storage.set('StatisticsAll', result);
          resolve(result);
        })
        .catch((err) => {
          this.storage.get('StatisticsAll').then((data) => {
            if (data == undefined) {
              let result: Array<AllocationModel> = [];
              reject(result);
            }
            reject(data);
          });
        });
    });
  }

  getStatisticForUser(): Promise<Array<StatisticModel>> {
    return new Promise(async (resolve) => {
      try {
        if (!this.http.userId) {
          resolve([]);
          return;
        }

        var response = await HttpUtils.handle<UserModel>({
          request: this.http.get(`${environment.web.identity}/api/users/${this.http.userId}`),
        });
        if (!response) resolve([]);
        else resolve(response.statistics || []);
      } catch (e) {
        console.error(e);
        resolve([]);
      }
    });
  }

  readBatchStatistics(ids: string[]) {
    return new Promise(async (resolve) => {
      try {
        if (!this.http.userId) {
          resolve(true);
          return;
        }

        await this.http.post(`${environment.web.identity}/api/statistics/read-batch`, { ids });

        resolve(true);
      } catch (e) {
        console.error(e);
        resolve(true);
      }
    });
  }

  creatAllocation(allocation: AllocationModel): AllocationModel {
    let users: Array<StatisticsUserModel> = [];
    for (let i = 0; i < allocation.users.length; i++) {
      let item = allocation.users[i];
      users.push(this.createUser(item));
    }
    return new AllocationModel(allocation.id, allocation.name, false, users);
  }

  createUser(data: StatisticsUserModel): StatisticsUserModel {
    return new StatisticsUserModel(data.firstname, data.lastname, data.id, data.isCheckedIn, true);
  }
}
